export const buildPrompt = ({
  selectedCategory,
  selectedColor,
  selectedStyle,
  selectedMode,
  selectedLighting,
  selectedFilter,
  specificSelections,
  customPrompt
}) => {
  if (!selectedCategory) return '';

  let subject = selectedCategory.name.toLowerCase();
  let details = [];

  Object.entries(specificSelections).forEach(([key, value]) => {
    if (!value) return;

    // Special handling for hex colors
    if (typeof value === 'string' && value.startsWith('#')) {
      details.push(`${key.toLowerCase()}: ${value}`);
    } else {
      details.push(value.toLowerCase());
    }
  });

  let prompt = 'A';
  if (selectedMode) prompt += ` ${selectedMode}`;
  if (selectedStyle) prompt += ` ${selectedStyle}`;
  prompt += ` image of ${subject}`;

  if (details.length) prompt += ` ${details.join(', ')}`;
  if (selectedLighting) prompt += `, ${selectedLighting} lighting`;
  if (selectedFilter) prompt += `, ${selectedFilter} filter`;

  if (selectedColor) {
    prompt += `, dominant color: ${selectedColor}`;
  }

  if (customPrompt) prompt += `. ${customPrompt}`;

  return `${prompt}. Highly detailed, masterpiece, sharp focus, professional composition.`;
};